export const invoiceCreateComputed = {
  hasBillingDataForPrefillCustomer() {
    const customerId = Number(this.prefillPaymentCustomerId || 0) || 0;
    if (customerId <= 0) {
      return false;
    }

    const options = Array.isArray(this.customerOptions) ? this.customerOptions : [];
    return options.some((option) => {
      const optionCustomerId = Number(
        option?.customerId
        || option?.meta?.customerId
        || option?.meta?.companyId
        || option?.companyId
        || 0
      ) || 0;

      return optionCustomerId === customerId;
    });
  },
  inlineBillingDataOnly() {
    return (Number(this.prefillPaymentId || 0) || 0) > 0
      && (Number(this.prefillPaymentCustomerId || 0) || 0) > 0
      && !this.hasBillingDataForPrefillCustomer;
  },
  subtotal() {
    return this.concepts.reduce((sum, concept) => {
      return sum + ((Number(concept?.qty || 0) * Number(concept?.unitPrice || 0)) || 0);
    }, 0);
  },
  discountAmount() {
    return this.subtotal * (Number(this.discountRate || 0) / 100);
  },
  taxAmount() {
    return this.transferredTaxAmount - this.withheldTaxAmount;
  },
  transferredTaxAmount() {
    return this.concepts.reduce((sum, concept) => {
      const explicit = Number(
        concept?.taxTransferredTotal
        ?? concept?.transferedTaxes
        ?? concept?.transferredTaxes
        ?? concept?.taxes?.transferred_total
      );

      if (Number.isFinite(explicit)) {
        return sum + explicit;
      }

      const fallbackTax = Number(concept?.taxAmount || 0);
      return sum + (fallbackTax > 0 ? fallbackTax : 0);
    }, 0);
  },
  withheldTaxAmount() {
    return this.concepts.reduce((sum, concept) => {
      const explicit = Number(
        concept?.taxWithheldTotal
        ?? concept?.withheldTaxes
        ?? concept?.taxes?.withheld_total
      );

      if (Number.isFinite(explicit)) {
        return sum + explicit;
      }

      const fallbackTax = Number(concept?.taxAmount || 0);
      return sum + (fallbackTax < 0 ? Math.abs(fallbackTax) : 0);
    }, 0);
  },
  total() {
    return (this.subtotal - this.discountAmount) + this.transferredTaxAmount - this.withheldTaxAmount;
  },
  editingConceptData() {
    if (this.editingConceptIndex < 0) {
      return null;
    }

    return this.concepts[this.editingConceptIndex] || null;
  },
};
